<div class="price">
  @if (costPerMonthWithoutDiscount) {
    <div class="price-tag price-tag--without-discount">
      <span class="price-tag__symbol">{{ currencySymbol }}</span>
      <span class="price-tag__amount">{{ costPerMonthWithoutDiscount | math: 'ceil' }}</span>
    </div>
  }
  <div class="price-tag price-tag--with-discount">
    <span class="price-tag__symbol">{{ currencySymbol }}</span>
    <span class="price-tag__amount">{{ costPerMonth | math: 'ceil' }}</span>
  </div>
  / {{ 'app.common.month' | translate }}
</div>
@if (interval === 12) {
  {{ 'app.pricing.plan_picker.when_paid_annually' | translate }}
}
